export default __webpack_public_path__ + "static/mathew-3c5c7dc254e0dfb0e7eb662519da599c.jpeg";